import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getUiInterface } from "../../locales/translationUtils";

interface ConfirmResetPasswordModalProps {
    show: boolean;
    /** Nome do usuário que terá a senha resetada, exibido na confirmação. */
    userName?: string;
    onHide: () => void;
    onConfirm: () => void;
}

/**
 * Confirmação do reset de senha: avisa que o usuário receberá a senha padrão
 * e um e-mail com o link para cadastrar a nova senha.
 */
const ConfirmResetPasswordModal: React.FC<ConfirmResetPasswordModalProps> = ({
    show,
    userName,
    onHide,
    onConfirm,
}) => {
    const { t } = useTranslation();

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("user.resetPassword.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{t("user.resetPassword.confirmMessage", { user: userName || "" })}</p>
                <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
                    {t("user.resetPassword.confirmDetail")}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {getUiInterface("no")}
                </Button>
                <Button variant="warning" onClick={onConfirm}>
                    {getUiInterface("yes")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmResetPasswordModal;
